import { Injectable } from '@angular/core';

@Injectable()

export class Logger {

  static colors = {
    error: 'red',
    warning: 'orange',
    info: 'blue',
    success: 'green',
  }

  static symbols = {
    error: '&#x21;',
    warning: '&#x26A0',
    info: '&#x2139;',
    success: '&#x2714;',
  }

  constructor() {}

  log(...args: any[]) {
    console.log.apply(console, args);
  }

  logEach(...args: any[]) {
    for(let arg of args) {
      this.log(arg);
    }
  }

  coloredLog(color: string, ...args: any[]) {
    this.log(`%c ${args[0].toUpperCase()} ----------> `, `color: ${color}`, ...args.slice(1));
  }

  errorLog(...args: any[]) {
    this.coloredLog(Logger.colors.error, ...args);
  }

  successLog(...args: any[]) {
    this.coloredLog(Logger.colors.success, ...args);
  }

  infoLog(...args: any[]) {
    this.coloredLog(Logger.colors.info, ...args);
  }

  warningLog(...args: any[]) {
    this.coloredLog(Logger.colors.warning, ...args);
  }

  private getSymbol(code: string): string {
    const elem = document.createElement('span');
    elem.innerHTML = code;
    return elem.innerHTML;
  }

}
